import * as actions from "../constants/actionTypes";
export const INITIAL_STATE = {
    contestDetails: {
        Category: {
            _id: "",
            created: "",
            modified: "",
            isDeleted: false,
            name: ""
        },
        category: "",
        created: "",
        createdBy: "",
        currentMonthContest: "",
        currentPrice: 0,
        currentPriceUnit: 0,
        defaultPic: "",
        flagGlobal: true,
        flagUserEnrolled: false,
        genderEnable: true,
        judges: [],
        judgesCount: 0,
        locationInfo: {
            country: "",
            city: "",
            countryName: "",
            countryFlag: ""
        },
        name: "",
        talents: 0,
        ticketsCounts: 0,
        voters: [],
        votersCount: 0,
        votes: 0,
        weight: 0,
        _id: ""
    },
    judgesCommittee: [],
    contesteeFeed: [],
    allContestants: [],
    firstCall: true,
    enrolledHostContest: [],
    newContestantsList: [],
    userVoteList: [],
    myVotesContestant: {},
    countryWiseContestant: [],
    dailyWinners: {},
    monthlyWinners: { list: [] },
    seeMoreData: {},
    seeMoreDataLoader: true,
    contestDetailsLoader: true,
    monthWinner: [],
    previousWinners: [],
    rankList: { list: [] },
    votersActivity: {},
    votersActivityIndex: 0,
    hasMore: true,
    hasMoreContestants: true,
};
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actions.GET_CONTEST_DETAIL:
            return {
                ...state,
                firstCall: false,
            }
        case actions.GET_CONTEST_DETAIL_SUCCESS:
            localStorage.setItem("loadMoreContestants", false);
            return {
                ...state,
                contestDetails: action.payload.contestDetails,
                judgesCommittee: action.payload.judgesCommittee,
                contesteeFeed: action.payload.contestents,
                allContestants: action.payload.talent,
                newContestantsList: action.payload.newContestantsList,
                userVoteList: action.payload.userVoteList,
                myVotesContestant: action.payload.myVotesContestant,
                countryWiseContestant: action.payload.countryWiseContestant,
                dailyWinners: action.payload.dailyWinners,
                monthlyWinners: action.payload.monthlyWinners,
                monthWinner: action.payload.monthWinner,
                previousWinners: action.payload.previousWinners,
                rankList: action.payload.rankList.list == undefined ? state.rankList : action.payload.rankList,
                votersActivity: action.payload.votersActivity,
                votersActivityIndex: 0,
                firstCall: false,
                contestDetailsLoader: false,
            }
        case actions.GET_JUDGES_COMMITTEE_SUCCESS:
            return {
                ...state,
                judgesCommittee: action.payload
            }
        case actions.GET_CONTESTEE_FEED_SUCCESS:
            return {
                ...state,
                contesteeFeed: action.payload
            }
        case actions.GET_ENROLLED_HOST_DATA_SUCCESS:
            return {
                ...state,
                enrolledHostContest: action.payload
            }
        case actions.SEE_MORE_DATA_SUCCESS:
            localStorage.setItem("loadMoreContest", false);
            return {
                ...state,
                seeMoreDataLoader: false,
                seeMoreData: action.payload.newData ? action.payload.seeMoreData : action.payload.seeMoreData.list == undefined ? { list: [...state.seeMoreData.list] } : { list: [...state.seeMoreData.list, ...action.payload.seeMoreData.list], totalRecords: action.payload.seeMoreData.totalRecords },
                hasMore: action.payload.seeMoreData.list == undefined ? false : action.payload.seeMoreData.list.length >= 10,
            }
        case actions.GET_CONTEST_DETAIL_TALENTS_SUCCESS: {
            localStorage.setItem("loadMoreContestants", false);
            return {
                ...state,
                allContestants: action.payload.newData == false ? [...state.allContestants, ...action.payload.allContestants] : [...state.allContestants],
                hasMoreContestants: action.payload.allContestants.length >= 5
            }
        }
        case actions.GET_VOTERS_ACTIVITY_SUCCESS:
            return {
                ...state,
                votersActivity: action.payload.votersActivity,
                votersActivityIndex: action.payload.votersActivityIndex,
            }
        case actions.RESET_CONTEST_DETAIL:
            return {
                contestDetails: {
                    Category: {
                        _id: "",
                        created: "",
                        modified: "",
                        isDeleted: false,
                        name: ""
                    },
                    category: "",
                    created: "",
                    createdBy: "",
                    currentMonthContest: "",
                    currentPrice: 0,
                    currentPriceUnit: 0,
                    defaultPic: "",
                    flagGlobal: true,
                    flagUserEnrolled: false,
                    genderEnable: true,
                    judges: [],
                    judgesCount: 0,
                    locationInfo: {
                        country: "",
                        city: "",
                        countryName: "",
                        countryFlag: ""
                    },
                    name: "",
                    talents: 0,
                    ticketsCounts: 0,
                    voters: [],
                    votersCount: 0,
                    votes: 0,
                    weight: 0,
                    _id: ""
                },
                judgesCommittee: [],
                contesteeFeed: [],
                allContestants: [],
                enrolledHostContest: [],
                newContestantsList: [],
                userVoteList: [],
                myVotesContestant: {},
                countryWiseContestant: [],
                dailyWinners: {},
                monthlyWinners: { list: [] },
                seeMoreData: {},
                seeMoreDataLoader: true,
                contestDetailsLoader: true,
                monthWinner: [],
                previousWinners: [],
                rankList: { list: [] },
                votersActivity: {},
                votersActivityIndex: 0,
            }
        case actions.SEND_CONTEST_LIKE_CONTEST_DETAIL_FEEDBACK_SUCCESS: {
            const { index, interactionType, from, mediaIndex } = action.payload;
            const { contesteeFeed } = state;
            if (interactionType == "B")
                contesteeFeed[index].enrolledContestMedia[mediaIndex].isBookmarkedFlag = !contesteeFeed[index].enrolledContestMedia[mediaIndex].isBookmarkedFlag;
            else
                contesteeFeed[index].enrolledContestMedia[mediaIndex].isLikedFlag = !contesteeFeed[index].enrolledContestMedia[mediaIndex].isLikedFlag;

            return {
                ...state,
                featuredVideo: [...featuredVideo]
            }
        }
        case actions.GET_CONTEST_DETAIL_MONTHLY_WINNERS_SUCCESS: {
            return {
                ...state,
                monthlyWinners: action.payload
            }
        }
        case actions.GIVE_VOTE_SUCCESS_CONTEST_DETAILS: {
            const { contesteeFeed } = state;
            if (contesteeFeed[action.payload].totalVotes != undefined)
                contesteeFeed[action.payload].totalVotes += 1;
            if (contesteeFeed[action.payload].todaysVotes != undefined)
                contesteeFeed[action.payload].todaysVotes += 1;
            if (contesteeFeed[action.payload].votesByMe != undefined)
                contesteeFeed[action.payload].votesByMe += 1;
            if (contesteeFeed[action.payload].isVotedByMe != undefined)
                contesteeFeed[action.payload].isVotedByMe = true;
            return {
                ...state,
                contesteeFeed: contesteeFeed
            }
        }
        case actions.UPDATE_MEDIA_VIEW_COUNT_SUCCESS:
            let { payload } = action;
            let { contesteeFeed } = state;
            contesteeFeed[action.payload.index].enrolledContestMedia[action.payload.index1].viewCount += 1;
            return {
                ...state,
                contesteeFeed: [...contesteeFeed]
            }
        case actions.CONTEST_DETAIL_ERROR:
            return {
                ...state,
                contestDetailsLoader: false
            }
        default:
            return state;
    }
};
